export default __webpack_public_path__ + "static/media/check_icon.7196c567.svg";